import script from "./TabBarTag.vue?vue&type=script&setup=true&lang=ts"
export * from "./TabBarTag.vue?vue&type=script&setup=true&lang=ts"

import "./TabBarTag.vue?vue&type=style&index=0&id=6ee04d6b&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ee04d6b"]])

export default __exports__